import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';
import { catchError, of } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../../../environments/environments';

@Component({
  selector: 'app-verify-email',
  imports: [    CommonModule,
    ButtonModule,
    CardModule,
    ProgressSpinnerModule,
    MessageModule],
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.scss'
})
export class VerifyEmailComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private http = inject(HttpClient);

  isLoading = true;
  isSuccess = false;
  errorMessage = '';
  token = '';
  userId = '';
  isAlreadyConfirmed = false;
  ngOnInit() {
    localStorage.clear();
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.userId = params['user_id'] 
      if (this.token) {
        this.verifyEmail();
      } else {
        this.handleError('Invalid verification link');
      }
    });
  }

  private verifyEmail() {
    if (!this.token) {
      this.handleError('No verification token provided');
      return;
    }

    const apiUrl =  `${environment.apiUrl}api/auth/confirm/${this.userId}/token/${this.token}`;

    this.http.post(apiUrl, {}).pipe(
      catchError(error => {
        console.error('Verification error:', error);
        return of({ error: error.error?.error || 'Verification failed' });
      })
    ).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.error) {
          this.handleError(response.error);
        } else if (response.message === 'Email already confirmed') {
          this.isAlreadyConfirmed = true;
          this.isSuccess = true;
        } else {
          this.isSuccess = true;
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.handleError('Network error occurred');
      }
    });
  }

  private handleError(message: string) {
    this.isLoading = false;
    this.isSuccess = false;
    this.errorMessage = message;
  }

  navigateToLogin() {
    this.router.navigate(['admin/login']);
  }

  resendVerification() {
    this.router.navigate(['/resend-verification']);
  }

  contactSupport() {
    window.open('mailto:younessayyoubi@gmail.com?subject=Email Verification Issue');
  }

}
